const RequestStatus = {
  OK_REQUEST_STATUS: 200,
  BAD_REQUEST_STATUS: 400,
  BAD_REQUEST_CODE: "ERR_BAD_REQUEST",
  ERR_NETWORK: "ERR_NETWORK"
};

export default RequestStatus;